export const ADD_NEW_FEE_PROVIDER = 'ADD_NEW_FEE_PROVIDER';
